<script setup lang="ts">
import { useTranslate } from "@/composables/useTranslate";
import { defineProps } from "vue";

const { t } = useTranslate();

defineProps<Props>();
type Props = {
  currentAppointment?: string;
  completedTermins?: number;
  completedTerminsPercentage?: number;
  bonus?: number;
  termins?: number;
  isReport: boolean;
};
</script>

<template>
  <div class="w-full grid grid-cols-3 items-center gap-[12.5px] mt-5">
    <!-- Current appointment -->
    <div v-if="!isReport" class="bg-white rounded-primary-radius p-3">
      <div class="flex items-center gap-2 mb-3">
        <img src="@/assets/location-frame-v2.svg" alt="Appointment" />
        <h4
          class="text-primary-text-color text-base custom-xl:text-lg leading-5 tracking-[0.01rem] font-semibold"
        >
          {{ t("installers.current_appointment") }}
        </h4>
      </div>
      <span
        class="text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal"
      >
        {{ currentAppointment ? currentAppointment : t("installers.none") }}
      </span>
    </div>
    <div v-if="isReport" class="bg-white rounded-primary-radius p-3">
      <div class="flex items-center gap-2 mb-3">
        <img src="@/assets/flag-frame-v2.svg" alt="Appointment month" />
        <h4
          class="text-primary-text-color text-base custom-xl:text-lg leading-5 tracking-[0.01rem] font-semibold"
        >
          {{ t("installers.bonus") }}
        </h4>
      </div>
      <span
        class="text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal"
        >{{ bonus ? `${bonus}€` : 0 }}</span
      >
    </div>
    <!-- Appointments this month -->
    <div class="bg-white rounded-primary-radius p-3">
      <div class="flex items-center gap-2 mb-3">
        <img src="@/assets/flag-frame-v2.svg" alt="Appointment month" />
        <h4
          class="text-primary-text-color text-base custom-xl:text-lg leading-5 tracking-[0.01rem] font-semibold"
        >
          {{ t("installers.appointments_this_month") }}
        </h4>
      </div>
      <span
        class="text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal"
        >{{ termins ? termins : 0 }}</span
      >
    </div>
    <!-- Success rate -->
    <div class="bg-white rounded-primary-radius p-3">
      <div class="flex items-center gap-2 mb-3">
        <img src="@/assets/star-frame-v2.svg" alt="Success rate" />
        <h4
          class="text-primary-text-color text-base custom-xl:text-lg leading-5 tracking-[0.01rem] font-semibold"
        >
          {{ t("installers.success_rate") }}
        </h4>
      </div>
      <div class="w-full flex items-center justify-between">
        <div class="w-full flex items-center">
          <span
            class="text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal"
            >{{ completedTermins ? completedTermins : "0" }}</span
          >
          <span
            class="text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal"
            >/</span
          >
          <span
            class="text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal"
            >{{ termins ? termins : "0" }}</span
          >
        </div>
        <span
          class="text-primary-text-color text-base custom-xl:text-lg leading-[22.5px] tracking-[0.01rem] font-normal"
          >{{
            completedTerminsPercentage ? `${completedTerminsPercentage}%` : "0%"
          }}</span
        >
      </div>
    </div>
  </div>
</template>
